import { Loader, Modal, SMBSelect } from '../../../../components';
import { IPunchlistTemplate, IResponse } from '../../../../models';
import { Close, Save } from '@mui/icons-material';
import { Box, MenuItem, ButtonGroup, Button } from '@mui/material';
import { FC, useContext, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { getPunchlistTemplates } from '../../../../fetch';
import { UserContext } from '../../../../context';

interface IPunchlistTemplateModal {
  isOpen: boolean;
  handleClose: (val?: string | number) => void;
  isUpdating: boolean;
}

const MAX_RECORDS = '2147483647';

export const PunchlistTemplateModal: FC<IPunchlistTemplateModal> = ({
  isOpen,
  handleClose,
  isUpdating
}) => {
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | number>('');
  const { isAdmin, isField, isFieldAdmin } = useContext(UserContext);
  const { isLoading: isLoadingTemplates, data: templatesData } = useQuery<
    IResponse<IPunchlistTemplate[]>,
    Error
  >(
    ['getPunchlistTemplates'],
    () =>
      getPunchlistTemplates({
        perPage: MAX_RECORDS
      }),
    {
      enabled: (isAdmin || isField || isFieldAdmin) && isOpen
    }
  );
  const templates = useMemo(() => templatesData?.records ?? [], [templatesData]);
  return (
    <Modal open={isOpen} onClose={handleClose} maxWidth="xs" title="Add Template to Punchlist">
      {isUpdating && <Loader type="overlay" position="centered" />}
      <Box mt={1}>
        <SMBSelect
          variant="outlined"
          disabled={isLoadingTemplates}
          label="Template"
          value={selectedTemplateId}
          size="small"
          onChange={({ target: { value } }) => {
            setSelectedTemplateId(value);
          }}
          handleClear={() => setSelectedTemplateId('')}
        >
          {!isLoadingTemplates && templates && templates.length === 0 && (
            <MenuItem disabled>No data available</MenuItem>
          )}
          {templates?.map((template, index) => {
            return (
              <MenuItem key={template.punchlistTemplateId} value={template.punchlistTemplateId}>
                {template.name}
              </MenuItem>
            );
          })}
        </SMBSelect>
        <Box mt={1}>
          <ButtonGroup>
            <Button
              disabled={!selectedTemplateId}
              type="button"
              onClick={() => {
                handleClose(Number(selectedTemplateId));
                setSelectedTemplateId('');
              }}
              variant="contained"
              color="primary"
              startIcon={<Save />}
            >
              Save
            </Button>
            <Button
              type="button"
              variant="contained"
              color="inherit"
              startIcon={<Close />}
              onClick={() => {
                handleClose();
                setSelectedTemplateId('');
              }}
            >
              Cancel
            </Button>
          </ButtonGroup>
        </Box>
      </Box>
    </Modal>
  );
};
